import { memo } from "react";
import * as Styled from "./style";
import { VideoLegacySeasonHeader } from "./video-legacy-season-header";
import { VideoSeasonHeader } from "./video-season-header";
import { RestrictedHeader } from "~/components/blocks/product/common/blocks/product-header-block";
import { VideoSpotLiveSeasonHeader } from "~/components/blocks/product/detail/header/video-spot-live-season-header";
import { VideoStageSeasonHeader } from "~/components/blocks/product/detail/header/video-stage-season-header";
import {
  isVideoLegacySeason,
  isVideoSeason,
  isVideoSpotLiveSeason,
  isVideoStageSeason,
} from "~/components/blocks/product/type-guard";
import { useRatingBlock } from "~/hooks/use-rating-block";
import type { G_GetVideoQuery } from "~/lib/graphql";

export const DETAIL_HEADER_ID = "detail-header";

// const MOCK_SAMPLE_VIDEO =
//   "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4";

type DetailHeaderProps = {
  videoData?: G_GetVideoQuery;
};

/**
 * 作品末端のヘッダー領域の条件分岐に責務を持つコンポーネント
 *
 * @機能要件
 * - 再生ボタン : 視聴権の有無で振る舞いが異なるので、視聴権の有無に応じて場合分けを行うこと
 * - 配信前（isBeingDelivered）の場合 : 再生ボタンを「非表示」にすること
 * - 視聴権ありの場合 : 再生ボタンを「表示」すること（7月12日以降、提供予定）
 * - 視聴権あり and レジュームありの場合 : 〜 を続きから再生 と再生アイコンの下に表示すること（7月12日以降、提供予定）
 * - 視聴権なし and PPVのみの場合 : 再生ボタン + 購入して再生 という文言を表示すること（7月12日以降、提供予定）
 */
export const DetailHeader = memo((props: DetailHeaderProps) => {
  const { videoData } = props;
  const { isRestrictedContentByUserStatus } = useRatingBlock();

  if (videoData?.video === undefined) return null;
  const { video } = videoData;
  const ratingCategory = video.rating.category;

  if (isRestrictedContentByUserStatus(ratingCategory, true))
    return (
      <Styled.DivDetailHeader id={DETAIL_HEADER_ID}>
        <RestrictedHeader />
      </Styled.DivDetailHeader>
    );

  return (
    <Styled.DivDetailHeader id={DETAIL_HEADER_ID}>
      {isVideoSeason(video) && <VideoSeasonHeader videoSeasonData={video} />}

      {isVideoLegacySeason(video) && <VideoLegacySeasonHeader videoLegacySeasonData={video} />}

      {isVideoStageSeason(video) && <VideoStageSeasonHeader videoStageSeasonData={video} />}

      {isVideoSpotLiveSeason(video) && <VideoSpotLiveSeasonHeader videoSpotLiveSeasonData={video} />}
    </Styled.DivDetailHeader>
  );
});

DetailHeader.displayName = "DetailHeader";
